import React, { useMemo, useState, useEffect, useCallback } from 'react'

import { Card, Button, Switch } from '@material-ui/core'
import FormItem from 'components/FormItem'
import { assign } from 'lodash'
import { partnerWorkoutResourceUpsertPromise } from 'api/PartnerWorkoutResource'
import { isBlank } from 'common/usual'
import { fetchWorkoutOptions, optionEnum } from '../concerns/workoutOptions'
import { AutoCompleteNew } from 'components/Select'

export default function PartnerWorkoutResourceForm (props) {
  const { data } = props
  const [partnerResource, setPartnerResource] = useState({})
  const [btnStatus, setBtnStatus] = useState(false)
  const [options, setOptions] = useState({})

  useEffect(() => {
    async function fetchOptions () {
      const _options = await fetchWorkoutOptions(optionEnum.resource, optionEnum.partner)
      setOptions(_options)
    }
    fetchOptions()
  }, [])

  const disableBtn = useMemo(() => (
    btnStatus || isBlank(partnerResource.name)
  ), [btnStatus, partnerResource.name])

  useEffect(() => {
    setPartnerResource(data)
  }, [data])

  function handleSubmit () {
    setBtnStatus(true)
    partnerWorkoutResourceUpsertPromise(partnerResource)
      .then(res => props.history.goBack())
      .finally(() => setBtnStatus(false))
  }

  const handleChange = useCallback((...values) => {
    setPartnerResource(
      assign({}, partnerResource, ...values)
    )
  }, [partnerResource])

  const commonProps = useMemo (() => ({
    onChange: handleChange,
    data: partnerResource
  }), [handleChange, partnerResource])

  return (
    <div className={'root'}>
      <Card className={'form-container'}>
        <FormItem label={'Name'} name={'name'} {...commonProps} />
        <FormItem label={'Male Name'} name={'nameMale'} {...commonProps} />
        <FormItem label={'About'} name={'workoutAbout'} {...commonProps} />
        <FormItem label={'Intensity'} name={'intensity'} type={'number'} {...commonProps} />

        <FormItem label={'Partner'} name={'partnerId'}>
          <AutoCompleteNew
            options={options.partner || []}
            value={partnerResource.partnerId}
            onChange={(event, selected) => {
              handleChange({ partnerId: (selected || {value: null}).value })
            }}
          />
        </FormItem>

        <FormItem label={'Workout Resource'} name={'workoutResourceId'}>
          <AutoCompleteNew
            options={options.workoutResource || []}
            value={partnerResource.workoutResourceId}
            onChange={(event, selected) => {
              handleChange({ workoutResourceId: (selected || {value: null}).value })
            }}
          />
        </FormItem>

        <FormItem label={'Active'} name={'active'}>
          <Switch
            checked={Boolean(partnerResource.active)}
            onChange={e => {
              handleChange({ active: e.target.checked })
            }}
            name="active"
            inputProps={{ 'aria-label': 'secondary checkbox' }}
          />
        </FormItem>

        <Button
          className="save-btn"
          color="primary"
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          onClick={handleSubmit}
          disabled={disableBtn}
        >
          SUBMIT
        </Button>
      </Card>
    </div>
  )
}